import { PHILOSOPHY_CARDS, PHILOSOPHY_QUOTE } from "../constants/philosophy.constant";

export function Philosophy() {
  return (
    <section id="philosophy" className="bg-surface pb-20 px-6 md:pb-35 md:px-13">
      <div className="max-w-6xl mx-auto border-t border-border pt-20 md:pt-35">
        <p className="section-label reveal">Philosophy</p>
        <blockquote className="not-italic text-[clamp(22px,3.5vw,52px)] font-bold tracking-[-0.01em] leading-tight text-primary max-w-4xl mb-20 reveal">
          {PHILOSOPHY_QUOTE}
        </blockquote>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-0.5">
          {PHILOSOPHY_CARDS.map((card, i) => (
            <div key={card.title} className="bg-surface-2 border-t border-border p-10 px-8 reveal">
              <span className="text-xs tracking-[0.3em] text-primary/65 block mb-5">
                {String(i + 1).padStart(2, "0")}
              </span>
              <h3 className="text-xl font-bold tracking-[-0.01em] text-primary mb-4">
                {card.title}
              </h3>
              <p className="text-[13px] leading-[1.8] text-primary/65">{card.body}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
